import { SpinnerProps } from '@ui-system/interfaces-spinner';

const defaultProps: Partial<SpinnerProps> = {
  size: 'medium',
  color: 'primary',
};
export default defaultProps;
